// The backdrop behind the public hiring pages: a grid that fades out towards
// the top and a blurred glow along the bottom. Styled in apply-page.css.
export function HiringStage() {
  return (
    <div className="apply-stage" aria-hidden="true">
      <svg>
        <defs>
          <pattern
            id="apply-stage-grid"
            x="0"
            y="-3"
            width="80"
            height="80"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 80 0 L 0 0 0 80"
              fill="transparent"
              stroke="currentColor"
              strokeWidth="1"
            />
          </pattern>
        </defs>
        <rect fill="url(#apply-stage-grid)" width="100%" height="100%" />
      </svg>
      <div className="apply-stage-glow">
        <i />
      </div>
    </div>
  );
}
